import _, { isObject } from "lodash";

export const orderedObjectArrayEqualityCheck = (a?: { order: number }[] | null, b?: { order: number }[] | null) => {
  if (a && b) {
    if (a.length !== b.length) return false;
    const sortedA = _.sortBy(a, "order").map((item) => _.omitBy(item, _.isNil));
    const sortedB = _.sortBy(b, "order").map((item) => _.omitBy(item, _.isNil));
    return sortedA.every((item, index) => {
      const itemB = sortedB[index];
      return Object.keys(item).every((key) => {
        if (key === "id") return true; //ignore id
        if (Array.isArray(item[key])) {
          return _.isEqual(item[key], itemB[key]);
        }
        if (isObject(item[key])) {
          return _.isEqual(item[key], itemB[key]);
        }
        return item[key] === itemB[key];
      });
    });
  }
  const aIsEmptyOrNull = !a || a.length === 0;
  const bIsEmptyOrNull = !b || b.length === 0;
  return aIsEmptyOrNull && bIsEmptyOrNull;
};
export const stringEqualityCheck = (a?: string | null, b?: string | null) => {
  if (a && b) {
    return a === b;
  }
  return !a && !b;
};
